import React, { Component } from "react";
import * as Sentry from "@sentry/browser";

class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { eventId: null };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		let currentUsername = "";
		let currentEmail = "";
		let currentId = "";
		let currentRole = "";

		if (sessionStorage.getItem("userData")) {
			const { email, firstName, lastName, id, role } = JSON.parse(
				sessionStorage.getItem("userData"),
			);

			currentUsername = firstName + lastName;
			currentEmail = email;
			currentId = id;
			currentRole = role;
		}

		Sentry.withScope((scope) => {
			scope.setUser({
				username: currentUsername,
				id: currentId,
				email: currentEmail,
				roleName: currentRole,
			});
			scope.setExtras(errorInfo);
			const eventId = Sentry.captureException(error);
			this.setState({ eventId });
		});
	}

	render() {
		if (this.state.hasError) {
			// Render a usable fallback instead of an empty fragment, otherwise the user
			// sees a fully blank page (regression reported against BT-993: "blank white
			// screen after creating a new user role"). Give them a clear message and a
			// way out.
			return (
				<div
					role="alert"
					style={{
						minHeight: "60vh",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						padding: "32px",
						textAlign: "center",
						color: "#3b3b3b",
					}}
				>
					<h1 style={{ fontSize: "24px", marginBottom: "16px" }}>
						Something went wrong
					</h1>
					<p
						style={{ maxWidth: "520px", marginBottom: "24px", lineHeight: 1.5 }}
					>
						The page hit an unexpected error and could not be displayed. Your
						work in this tab may not have been saved.
					</p>
					<div style={{ display: "flex", gap: "12px" }}>
						<button
							type="button"
							onClick={() => window.location.reload()}
							style={{
								padding: "10px 20px",
								background: "#ff5c5c",
								color: "#fff",
								border: "none",
								borderRadius: "4px",
								cursor: "pointer",
								fontSize: "14px",
							}}
						>
							Reload page
						</button>
						<a
							href="mailto:support@viso.ai"
							style={{
								padding: "10px 20px",
								border: "1px solid #ff5c5c",
								color: "#ff5c5c",
								borderRadius: "4px",
								textDecoration: "none",
								fontSize: "14px",
							}}
						>
							Contact support
						</a>
					</div>
				</div>
			);
		}

		// when there's not an error, render children untouched
		return this.props.children;
	}
}

export default ErrorBoundary;
